module.exports = __webpack_public_path__ + "static/media/close-icon.e1249791.svg";